import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Paper } from "@material-ui/core";
import { BootstrapTable } from "react-bootstrap-table";

function List({
  className = "",
  initialData = [],
  title,
  itemKey,
  getUrl,
  getParams,
  getProcess,
  children,
  itemSelected = () => {},
  pagination = true,
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [data, setData] = useState(initialData);

  /**
   * GET
   */
  const requestData = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      (getUrl instanceof Function ? getUrl(userInfo) : getUrl);

    let request;

    if (getParams) {
      request = axios.post(
        url,
        getParams instanceof Function ? getParams(userInfo) : undefined
      );
    } else {
      request = axios.get(url);
    }

    request
      .then((response) => response.data)
      .then((data) => {
        if (getProcess instanceof Function) {
          data = getProcess(data);
        }
        setData(data);
        if (data) {
          const row = data?.[0];
          setSelectedRow(row?.[itemKey]);
          itemSelected(row);
        }
      });
  }, [getUrl, itemKey, userInfo, itemSelected, getParams, getProcess]);

  /**
   * Initial load
   */
  useEffect(() => {
    if (getUrl) {
      requestData();
    }
  }, [getUrl, requestData]);

  /**
   * TABLE OPTIONS
   */
  const options = {
    page: 1, // which page you want to show as default
    hideSizePerPage: true,
    sizePerPage: 15, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "<", // Previous page button text
    nextPage: ">", // Next page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    withFirstAndLast: false, // Hide the going to First and Last page button
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const handleRowClick = (row) => {
    setSelectedRow(row[itemKey]);
    itemSelected(row);
  };

  const selectRow = {
    mode: "radio", // 'checkbox' for multiple selection, 'radio' for single selection
    clickToSelect: true,
    selected: [selectedRow],
    onSelect: handleRowClick,
  };

  return (
    <div id="main-div" className={`${className} !h-max w-60 flex-grow-0`}>
      <Paper>
        <h2>{title}</h2>

        <BootstrapTable
          data={data}
          options={options}
          pagination={pagination}
          selectRow={selectRow}
          version="4"
          hover
        >
          {children}
        </BootstrapTable>
      </Paper>
    </div>
  );
}

export default List;
